import src from "IMAGE";
export default { src, width: 800, height: 128, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AKFJDpZNLRZHQ0NDP1xcXFdqampmZWVlYVRUVFBqamplrF4K/DLDSDcAAAAASUVORK5CYII="};
